import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PartnerPolicySchema = withDefaults({
  type: 'partner-policy',
  fields: [
    {
      kind: 'attribute',
      name: 'policies',
    },
    {
      kind: 'attribute',
      name: 'programs',
    },
    {
      kind: 'attribute',
      name: 'programMap',
    },
    {
      kind: 'attribute',
      name: 'versionRef',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default PartnerPolicySchema;
